import * as React from 'react';
import { SVGProps } from 'react';

const IconKernStrokedSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 20.5v-13C5 5.015 9.03 3 14 3s9 2.015 9 4.5v13c0 2.485-4.03 4.5-9 4.5s-9-2.015-9-4.5Zm14.819-13a3.99 3.99 0 0 0-.797-.499C17.892 6.436 16.121 6 14 6c-2.12 0-3.892.436-5.022 1.001-.4.2-.647.372-.797.499.15.127.397.299.797.499C10.108 8.564 11.88 9 14 9s3.892-.436 5.022-1.001c.4-.2.647-.372.797-.499ZM14 12c2.305 0 4.408-.433 6-1.146v6.292C18.408 16.433 16.305 16 14 16s-4.408.433-6 1.146v-6.292C9.592 11.567 11.695 12 14 12Zm5.022 8.001c.4.2.647.372.797.499a3.99 3.99 0 0 1-.797.499C17.892 21.564 16.121 22 14 22c-2.12 0-3.892-.436-5.022-1.001a3.99 3.99 0 0 1-.797-.499 3.99 3.99 0 0 1 .797-.499C10.108 19.436 11.88 19 14 19s3.892.436 5.022 1.001Zm1.016.74-.005-.01.003.008.002.002Z"
    />
  </svg>
);
export default IconKernStrokedSizeL;
